// Valued clients — includes real logo paths (extracted from the company profile).
export const CLIENTS = [
  { name: "AKP Foundries", short: "AKP", image: "/images/clients/akp-foundries.png" },
  { name: "Ashok Iron Works", short: "AIW", image: "/images/clients/ashok-iron-works.png" },
  { name: "Bapuji Institute of Engineering & Technology", short: "BIET", image: "/images/clients/bapuji-biet.png" },
  { name: "Belgaum Aqua Valves Pvt. Ltd.", short: "BAV", image: "/images/clients/belgaum-aqua-valves.png" },
  { name: "CG Power & Industrial Solutions Ltd.", short: "CG", image: "/images/clients/cg-power.png" },
  { name: "Girnar Precision Technologies", short: "GIRNAR", image: "/images/clients/girnar-precision.png" },
  { name: "Hughes Precision Manufacturing", short: "HUGHES", image: "/images/clients/hughes-precision.png" },
  { name: "Hydropack (India) Pvt. Ltd.", short: "HYDROPACK", image: "/images/clients/hydropack.png" },
  { name: "Indian Cane Power Limited", short: "ICP", image: "/images/clients/indian-cane-power.png" },
  { name: "Jinabakul Forge Pvt. Ltd.", short: "JINABAKUL", image: "/images/clients/jinabakul-forge.png" },
  { name: "Manjushree Technopack", short: "MANJUSHREE", image: "/images/clients/manjushree.png" },
  { name: "Minco (India) Flow Elements Pvt. Ltd.", short: "MINCO", image: "/images/clients/minco.png" },
  { name: "Oasis International", short: "OASIS", image: "/images/clients/oasis-international.png" },
  { name: "Prakash Home Industries", short: "PRAKASH", image: "/images/clients/prakash-home.png" },
  { name: "REC Engineering Products Pvt. Ltd.", short: "REC", image: "/images/clients/rec-engineering.png" },
  { name: "Servocontrols Hydraulics India Pvt. Ltd.", short: "SERVO", image: "/images/clients/servocontrols.png" },
  { name: "SFS Group India", short: "SFS", image: "/images/clients/sfs-group.png" },
  { name: "Shanti Foumach Pvt. Ltd.", short: "SHANTI", image: "/images/clients/shanti-foumach.png" },
  { name: "Super Tech Engineers", short: "SUPERTECH", image: "/images/clients/super-tech.png" },
  { name: "Tool Holders Pvt. Ltd.", short: "TOOL HOLDERS", image: "/images/clients/tool-holders.png" },
];

export const INDUSTRIES = [
  "Engineering",
  "Manufacturing",
  "Fabrication",
  "Automotive",
  "Casting & Foundry",
  "Agricultural Equipment",
  "Construction Equipment",
  "Aerospace",
  "Pharmaceutical",
  "Oil & Gas",
  "Die & Mould",
  "CNC Machining Centres",
  "Tool Rooms",
];
